import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  returnsFilterType: null,
};

export const returnsFiltersSlice = createSlice({
  name: "returnsFilters",
  initialState,
  reducers: {
    setReturnsFilterType: (state, action) => {
      state.returnsFilterType = action.payload;
    },
  },
});

export const { setReturnsFilterType } = returnsFiltersSlice.actions;

export const getReturnsFilterType = (state) =>
  state.returnsFilters.returnsFilterType;

export default returnsFiltersSlice.reducer;
